import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=284d59e6&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
import style0 from "./camera.vue?vue&type=style&index=0&id=284d59e6&prod&lang=less&scoped=true"
import style1 from "./camera.vue?vue&type=style&index=1&id=284d59e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d59e6",
  null
  
)

export default component.exports